export default "__VITE_ASSET__BDJ62lCv__"